import { computed, type ComputedRef } from 'vue'
import { useServices } from '~/api/models'
import { useAuthStore } from '~/stores/authStore'

export const useSiteDelimitation = (): ComputedRef<boolean> => {
  const authStore = useAuthStore()
  const { data: sites } = useServices().locations.useGetAllSitesQuery()

  const reachableSiteCount = computed<number | undefined>(() => {
    const reach = authStore.siteReach
    if (reach && !reach.unrestricted) {
      return reach.siteIds.length
    }

    return sites.value?.length
  })

  return computed<boolean>(() => authStore.isSiteScopeEnabled && reachableSiteCount.value !== 1)
}
